import { currencyCodeToSymbol } from "@jugl-web/utils";

export const getCurrencySymbol = (currency: string) =>
  currencyCodeToSymbol(currency);
